export enum UserRouteParameterEnum {
  edit = 'edit',
  duplicate = 'duplicate',
}
